import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Select
} from "@mui/material";
import { Add, Photo } from "@mui/icons-material";
import { Autocomplete } from "@mui/lab";
import React, { Component } from "react";
import swal from "sweetalert";
import { DeliveraCategoryInterface } from "../../../controller/model/delivera/DeliveraCategorie";
import { DeliveraItemInterface } from "../../../controller/model/delivera/DeliveraItem";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";
import { DeliveraModifierGroupInterface } from "../../../controller/model/delivera/interface";
import PopinaRestaurant, {
  PopinaMappedItemInterface,
} from "../../../controller/model/popina/PopinaRestaurant";
import Environment from "../../../utils/Environement";
import ImagePickerModalComponent from "../../image/ImagePickerModalComponent";

interface PropsInterface {
  store: DeliveraStore;
  restaurant: PopinaRestaurant;
  onClickSave: (itemUpdated: DeliveraItemInterface) => void;
  onClickCreate: (
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface
  ) => void;
  onClickRemove: (
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface
  ) => void;
  onClickGroupeOption: (groupeOption: DeliveraModifierGroupInterface) => void;
}

interface StateInterface {
  title: string;
  description: string;
  image: string;
  price: string;
  tva: string;
  posID: string;
  isAlcool: boolean;
  modifier_ids: string[];
  menuOptionElement: any | null;
  isOpen: boolean;
  item: DeliveraItemInterface | undefined;
  category: DeliveraCategoryInterface | undefined;
}

export class ItemDetailModalComponet extends Component {
  public props: PropsInterface;
  public state: StateInterface;

  private imagePickerRef: React.RefObject<ImagePickerModalComponent>;

  constructor(props: any) {
    super(props);
    this.props = props;
    this.state = {
      title: "",
      description: "",
      image: "",
      price: "0.00",
      tva: "10",
      posID: "",
      isAlcool: false,
      modifier_ids: [],
      menuOptionElement: null,
      isOpen: false,
      item: undefined,
      category: undefined,
    };
    this.imagePickerRef = React.createRef();
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.openModalWithItem = this.openModalWithItem.bind(this);
    this.createUpdateItem = this.createUpdateItem.bind(this);
    this.handleClickSave = this.handleClickSave.bind(this);
    this.findPopinaItemWithPosID = this.findPopinaItemWithPosID.bind(this);
    this.handleSelectImageItem = this.handleSelectImageItem.bind(this);
  }

  componentDidMount() { }

  componentWillUnmount() { }

  public openModalWithItem(
    item: DeliveraItemInterface | undefined,
    category: DeliveraCategoryInterface | undefined
  ) {
    this.setState({
      item: item,
      image: item?.image_url ?? "",
      title: DeliveraStore.retreiveNameFromTranslation(item?.title),
      description: DeliveraStore.retreiveNameFromTranslation(item?.description),
      price: item ? (item.price_info.price / 100).toFixed(2) : "0.00",
      tva: item?.tax_info.vat_rate_percentage
        ? `${item.tax_info.vat_rate_percentage}`
        : "10",
      posID: item?.external_data ?? "",
      isAlcool: item?.dish_info?.classifications?.alcoholic_items ?? 0 >= 1,
      modifier_ids: item?.modifier_group_ids?.ids ?? [],
      menuOptionElement: null,
      category: category,
      isOpen: true,
    });
  }

  render() {
    return (
      <div style={{ overflow: "scroll" }}>
        <ImagePickerModalComponent
          handleAddImage={(url) => {
            this.setState({ image: url });
            this.imagePickerRef.current?.handleCloseModal();
          }}
          handleSelectImage={(url) => {
            this.setState({ image: url });
            this.imagePickerRef.current?.handleCloseModal();
          }}
          ref={this.imagePickerRef}
        />
        <Dialog
          open={this.state.isOpen}
          aria-labelledby="form-dialog-title"
          onClose={this.handleCloseModal}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle style={{ backgroundColor: "#474F5E", color: "white" }}>
            {this.state.item
              ? `Mofification de ${DeliveraStore.retreiveNameFromTranslation(
                this.state.item?.title
              )}`
              : "Creation d'un Produit"}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "20px",
              }}
            >
              <div
                className={"icon"}
                style={{
                  display: "inline-block",
                  alignSelf: "center",
                  width: "40%",
                  height: "40%",
                }}
              >
                {this.state.image !== undefined &&
                  this.state.image.length !== 0 ? (
                    <img
                      src={this.state.image}
                      alt="item"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        display: "block",
                      }}
                      onClick={this.handleSelectImageItem}
                    />
                  ) : (
                    <IconButton onClick={this.handleSelectImageItem}>
                      <Photo
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
                          color: "white",
                        }}
                      />
                    </IconButton>
                  )}
              </div>
              <div
                style={{
                  display: "inline-block",
                  width: "40%",
                }}
                className="textField"
              >
                <div style={{ width: "100%", marginBottom: "15px" }}>
                  <span
                    style={{
                      color: "#474F5E",
                      fontSize: "17px",
                      marginBottom: "5px",
                    }}
                  >
                    Nom du produit
                  </span>
                  <div style={{ padding: "5px" }}>
                    <TextField
                      fullWidth={true}
                      variant="outlined"
                      value={this.state.title}
                      onChange={(event) => {
                        this.setState({ title: event.target.value });
                      }}
                    />
                  </div>
                </div>

                <div style={{ width: "100%", marginBottom: "15px" }}>
                  <span
                    style={{
                      color: "#474F5E",
                      fontSize: "17px",
                      marginBottom: "5px",
                    }}
                  >
                    Description du produit
                  </span>
                  <div style={{ padding: "5px" }}>
                    <TextField
                      multiline
                      fullWidth={true}
                      variant="outlined"
                      value={this.state.description}
                      onChange={(event) => {
                        this.setState({ description: event.target.value });
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "100%", marginBottom: "15px" }}>
                    <span
                      style={{
                        color: "#474F5E",
                        fontSize: "17px",
                        marginBottom: "5px",
                      }}
                    >
                      Prix du produit
                    </span>
                    <div style={{ padding: "5px" }}>
                      <TextField
                        fullWidth={true}
                        variant="outlined"
                        value={this.state.price}
                        onChange={(event) => {
                          this.setState({ price: event.target.value });
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ width: "70%" }}>
                    <div style={{ padding: "5px" }}>
                      <span
                        style={{
                          color: "#474F5E",
                          fontSize: "17px",
                          marginBottom: "5px",
                        }}
                      >
                        TVA
                      </span>
                      <FormControl fullWidth={true}>
                        <Select
                          fullWidth={true}
                          labelId="tva-select-label"
                          variant="outlined"
                          value={parseFloat(this.state.tva)}
                          defaultValue={10}
                          onChange={(event) => {
                            this.setState({ tva: event.target.value });
                          }}
                        >
                          <MenuItem value={"10"}>10%</MenuItem>
                          <MenuItem value={"20"}>20%</MenuItem>
                          <MenuItem value={"5.5"}>5.5%</MenuItem>
                          <MenuItem value={"5"}>5%</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "95%",
                marginLeft: "20px",
                display: "inline-block",
                marginTop: "20px",
              }}
            >
              <span
                style={{
                  color: "#474F5E",
                  fontSize: "17px",
                  marginBottom: "5px",
                }}
              >
                Produit { Environment.isPopina ? "popina" : "jalia"} correspondant
              </span>
              <Autocomplete
                id="combo-box-popina"
                options={this.props.restaurant
                  .getAllMappedItems()
                  .sort((a, b) => {
                    const nameA = a.category;
                    const nameB = b.category;
                    if (nameA < nameB) {
                      return -1;
                    }
                    if (nameA > nameB) {
                      return 1;
                    }
                    return 0;
                  })
                }
                groupBy={(item) => item.category.toLowerCase()}
                value={this.findPopinaItemWithPosID()}
                getOptionLabel={(item) => `${item.name}`}
                onChange={(_event, data) => {
                  if (data) {
                    this.setState({ posID: data.id });
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" margin="dense" />
                )}
              />
            </div>
            <div
              style={{
                width: "95%",
                marginLeft: "20px",
                display: "inline-block",
                marginTop: "20px",
              }}
            >
              <span
                style={{
                  color: "#474F5E",
                  fontSize: "17px",
                  marginBottom: "5px",
                }}
              >
                Groupe d'options :
              </span>
              <div style={{ marginTop: "10px" }}>
                <div
                  style={{
                    display: "inline-block",
                    margin: "auto",
                    overflow: "scroll",
                  }}
                >
                  {this.props.store
                    .getGroupeOptionFromIds(this.state.modifier_ids)
                    .map((aGroupeOption) => (
                      <Fab
                        key={aGroupeOption.id}
                        variant="extended"
                        size="large"
                        color="secondary"
                        aria-label="add"
                        style={{ margin: "13px", color: "white" }}
                        onClick={() => {
                          this.props.onClickGroupeOption(aGroupeOption);
                        }}
                      >
                        {DeliveraStore.retreiveNameFromTranslation(
                          aGroupeOption.title
                        )}
                      </Fab>
                    ))}
                  <Fab
                    variant="extended"
                    size="medium"
                    color="secondary"
                    aria-label="add"
                    style={{ margin: "13px", color: "white" }}
                    onClick={(event) => {
                      this.setState({
                        menuOptionElement: event.currentTarget,
                      });
                    }}
                  >
                    <Add />
                  </Fab>
                  <Menu
                    id="simple-menu"
                    anchorEl={this.state.menuOptionElement}
                    keepMounted
                    open={Boolean(this.state.menuOptionElement)}
                    onClose={() => this.setState({ menuOptionElement: null })}
                  >
                    {this.props.store.modifier_groups.map(
                      (aGroupeOption, index) => {
                        return (
                          <MenuItem
                            key={index}
                            onClick={() => {
                              const optionsId = aGroupeOption.modifier_options.map((e) => e.id);
                              if (optionsId.includes(this.state.item?.id ?? "")) {
                                swal({
                                  title: "Attention",
                                  text: "Cet article est déjà assigné à un groupe d'option",
                                  icon: "warning",
                                  dangerMode: true,
                                })
                                return;
                              }

                              this.setState({
                                menuOptionElement: null,
                                modifier_ids: [
                                  this.props.store.modifier_groups[index].id,
                                ].concat(this.state.modifier_ids),
                              });
                            }}
                          >
                            {DeliveraStore.retreiveNameFromTranslation(
                              aGroupeOption.title
                            )}
                          </MenuItem>
                        );
                      }
                    )}
                  </Menu>
                </div>
              </div>
            </div>
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                width: "95%",
                marginTop: "20px",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#474F5E",
                  fontSize: "17px",
                  marginBottom: "5px",
                }}
              >
                Produit contenant de l'alcool :{" "}
              </span>
              <div
                style={{
                  marginLeft: "150px",
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                <Switch
                  color="primary"
                  checked={this.state.isAlcool}
                  onChange={(value) => {
                    this.setState({ isAlcool: !this.state.isAlcool });
                  }}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions style={{ margin: "20px" }}>
            <div style={{ justifyContent: "flex-start" }}>
              {this.state.item ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#D9D9D9", color: "white" }}
                  onClick={(_e) => {
                    this.props.onClickRemove(
                      this.state.item!,
                      this.state.category!
                    );
                  }}
                >
                  Supprimer
                </Button>
              ) : (
                  <div></div>
                )}
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCloseModal}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.handleClickSave}
              style={{ color: "white" }}
            >
              Enregister
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  private handleSelectImageItem(_e: any | undefined) {
    this.imagePickerRef.current?.openModal();
  }

  public handleCloseModal(_event?: any) {
    this.setState({ isOpen: false });
  }

  private handleClickSave(_e: any) {
    if (this.state.item) {
      this.props.onClickSave(this.createUpdateItem());
    } else {
      this.props.onClickCreate(this.createUpdateItem(), this.state.category!);
    }
  }

  private createUpdateItem(): DeliveraItemInterface {
    let updatedItem: DeliveraItemInterface = Object.assign({}, this.state.item);
    updatedItem["title"] = {
      translations: {
        fr: this.state.title,
      },
    };
    updatedItem["description"] = {
      translations: {
        fr: this.state.description,
      },
    };
    if (this.state.image.length !== 0) {
      updatedItem["image_url"] = this.state.image;
    }
    if (this.state.item) {
      updatedItem.price_info.price = parseInt(
        (parseFloat(this.state.price) * 100).toFixed(2)
      );
      updatedItem.tax_info.vat_rate_percentage = parseInt(this.state.tva);
      updatedItem.external_data = this.state.posID;
      if (updatedItem.dish_info && updatedItem.dish_info.classifications) {
        updatedItem.dish_info.classifications.alcoholic_items = Number(
          this.state.isAlcool
        );
      } else {
        updatedItem.dish_info = {
          classifications: {
            alcoholic_items: Number(this.state.isAlcool),
          },
        };
      }
      if (updatedItem.modifier_group_ids) {
        updatedItem.modifier_group_ids.ids = this.state.modifier_ids;
      }
    } else {
      updatedItem.price_info = {
        price: parseInt((parseFloat(this.state.price) * 100).toFixed(2)),
        context_value: this.state.price,
        context_type: "ITEM",
      };
      updatedItem.tax_info = {
        vat_rate_percentage: parseInt(this.state.tva),
      };
      updatedItem.external_data = this.state.posID;
      updatedItem.dish_info = {
        classifications: {
          alcoholic_items: this.state.isAlcool ? 1 : 0,
          can_serve_alone: true,
          is_vegetarian: false,
        },
      };
      updatedItem.modifier_group_ids = {
        ids: this.state.modifier_ids,
      };
    }

    return updatedItem;
  }

  private findPopinaItemWithPosID(): PopinaMappedItemInterface | null {
    const popinaItem = this.props.restaurant
      .getAllMappedItems()
      .find((i) => i.id === this.state.posID);
    return popinaItem ? popinaItem : null;
  }
}
